import Vue from 'vue'
import Vuex from 'vuex'
import * as MUTATIONS from './mutation-types'
import * as ACTIONS from './action-types'
import initialState from './initial-state'
import Api from '../services/Api'
import VuexPersist from 'vuex-persist';
import config from '../plugins/externalConfig'

Vue.use(Vuex);

var key = 'sme-direct-price-list';

// if a present manufacturer, store settings under a different key
// and change the initial state before it is passed to the store
if (config.manufacturer > 0) {
    key = key + '__manu-' + config.manufacturer;

    initialState.FILTER_MANUFACTURER = config.manufacturer;
    initialState.PRESET_MANUFACTURER = true;
}

const vuexLocalStorage = new VuexPersist({
    key: key, // The key to store the state on in the storage provider.
    storage: window.localStorage,
});

export default new Vuex.Store({
    plugins: [vuexLocalStorage.plugin],
    state: initialState,
    mutations: {
        [MUTATIONS.STATE]: (state, value) => state.STATE = value,
        [MUTATIONS.MODELS]: (state, value) => state.MODELS = value,
        [MUTATIONS.ERROR]: (state, value) => state.ERRORS = {...state.ERRORS, value},
        [MUTATIONS.OFFERS_FULL]: (state, value) => state.OFFERS_FULL = value,
        [MUTATIONS.OFFERS_FULL_COUNT]: (state, value) => state.OFFERS_FULL_COUNT = value,
        [MUTATIONS.CMS_DISCLAIMER]: (state, value) => state.CMS_DISCLAIMER = value,
        [MUTATIONS.FINANCE_FILTER_TERM]: (state, value) => state.FINANCE_FILTER_TERM = value,
        [MUTATIONS.FINANCE_FILTER_ADVANCE]: (state, value) => state.FINANCE_FILTER_ADVANCE = value,
        [MUTATIONS.FINANCE_FILTER_MILEAGE]: (state, value) => state.FINANCE_FILTER_MILEAGE = value,
        [MUTATIONS.FINANCE_FILTER_MAINT]: (state, value) => state.FINANCE_FILTER_MAINT = value,
        [MUTATIONS.SME_DESCRIPTIONS]: (state, value) => state.SME_DESCRIPTIONS = value,
        [MUTATIONS.VEHICLE]: (state, value) => state.VEHICLE = value,
        [MUTATIONS.SEARCH_RESULTS]: (state, value) => state.SEARCH_RESULTS = value,
        [MUTATIONS.SEARCH_BUSY]: (state, value) => state.SEARCH_BUSY = value,
        [MUTATIONS.SEARCH_RESULTS_COUNT]: (state, value) => state.SEARCH_RESULTS_COUNT = value,
        [MUTATIONS.SEARCH_RESULTS_PER_PAGE]: (state, value) => state.SEARCH_RESULTS_PER_PAGE = value,
        [MUTATIONS.SEARCH_RESULTS_PAGE]: (state, value) => state.SEARCH_RESULTS_PAGE = value,
        [MUTATIONS.FILTER_DATA_BODY]: (state, value) => state.FILTER_DATA_BODY = value,
        [MUTATIONS.FILTER_DATA_MANUFACTURER]: (state, value) => state.FILTER_DATA_MANUFACTURER = value,
        [MUTATIONS.FILTER_DATA_MODEL]: (state, value) => state.FILTER_DATA_MODEL = value,
        [MUTATIONS.FILTER_MANUFACTURER]: (state, value) => state.FILTER_MANUFACTURER = value,
        [MUTATIONS.FILTER_FUEL_TYPE]: (state, value) => state.FILTER_FUEL_TYPE = value,
        [MUTATIONS.FILTER_CO2]: (state, value) => state.FILTER_CO2 = value,
        [MUTATIONS.FILTER_RENTAL]: (state, value) => state.FILTER_RENTAL = value,
        [MUTATIONS.FILTER_BODY]: (state, value) => state.FILTER_BODY = value,
        [MUTATIONS.FILTER_MODEL]: (state, value) => state.FILTER_MODEL = value,
        [MUTATIONS.FILTER_TYPE]: (state, value) => state.FILTER_TYPE = value,
        [MUTATIONS.FILTER_ORDER]: (state, value) => state.FILTER_ORDER = value,
        [MUTATIONS.FILTER_DATA_FUEL_TYPES]: (state, value) => state.FILTER_DATA_FUEL_TYPES = value,
        [MUTATIONS.RESET]: (state) => {Object.assign(state, initialState)},
        [MUTATIONS.PRESET_MANUFACTURER]: (state, value) => state.PRESET_MANUFACTURER = value,
        [MUTATIONS.MANUFACTURER_LIST]: (state, value) => state.MANUFACTURER_LIST = value
    },
    getters: {
        selectedOffer: state => {
            if(state.VEHICLE) {
                return state.VEHICLE.finance.find(function (finance) {
                    return (finance.initial == state.FINANCE_FILTER_ADVANCE
                        && finance.mileage == state.FINANCE_FILTER_MILEAGE
                        && finance.term == state.FINANCE_FILTER_TERM);
                });
            }
            return null;
        },
        bodyStyles: state => type => {
            const typeObject = state.FILTER_DATA_BODY.find(function(value){
               return value.type === type;
            });
            if (typeObject !== undefined) {
                return typeObject.bodyStyles;
            }
            return [];
        },
        availableTerms: state => {
            if (state.VEHICLE) {
                return [...new Set(state.VEHICLE.finance.map(item => item.term))];
            }
        },
        availableMileage: state => {
            if (state.VEHICLE) {
                return [...new Set(state.VEHICLE.finance.map(item => item.mileage))];
            }
        },
        availableAdvance: state => {
            if (state.VEHICLE) {
                return [...new Set(state.VEHICLE.finance.map(item => item.initial))];
            }
        },
        isSpecial: (state) => {
            if (state.VEHICLE === null) {
                return false;
            }
            return (state.VEHICLE.finance.find(function(finance){
                return (finance.mileage === state.FINANCE_FILTER_MILEAGE
                    && finance.term === state.FINANCE_FILTER_TERM
                    && finance.initial === state.FINANCE_FILTER_ADVANCE
                    && finance.offer === true);
            }) !== undefined);
        }
    },
    actions: {
        [ACTIONS.GET_MODELS]: (context) => {
            Api.getModels(
                (models) => {
                    context.commit(MUTATIONS.MODELS, models);
                },
                (message) => {
                    context.commit(MUTATIONS.ERROR, message);
                }
            );

        },
        [ACTIONS.GET_OFFERS_FULL]: (context, params) => {
            Api.getOffers(
                params.data,
                (response) => {
                    context.commit(MUTATIONS.OFFERS_FULL, response.data  || []);
                    context.commit(MUTATIONS.OFFERS_FULL_COUNT, response.meta.itemsTotal);
                    if(typeof params.callback === "function") {
                        params.callback();
                    }
                },
                (message) => {
                    context.commit(MUTATIONS.ERROR, message);
                }
            );
        },
        [ACTIONS.GET_DISCLAIMER]: (context, id) => {
            Api.getDisclaimer(
                id,
                (response) => {
                    if(response.meta.items > 0) {
                        context.commit(MUTATIONS.CMS_DISCLAIMER, response.data.value);
                    }
                },
                (message) => {
                    context.commit(MUTATIONS.ERROR, message);
                }
            )
        },
        [ACTIONS.GET_SME_DESCRIPTIONS]: (context) => {
            Api.getSmeDescriptions(
                (response) => {
                    if(response.meta.items > 0) {
                        context.commit(MUTATIONS.SME_DESCRIPTIONS, response.data);
                    }
                },
                (message) => {
                    context.commit(MUTATIONS.ERROR, message);
                }
            );
        },
        [ACTIONS.GET_VEHICLE]: (context, options) => {
            Api.getVehicle(
                    options.slug,
                (response) => {
                    if(response.meta.items > 0) {
                        context.commit(MUTATIONS.VEHICLE, response.data);
                    } else {
                        context.commit(MUTATIONS.VEHICLE, null);
                    }
                    options.callback();
                },
                (message) => {
                    context.commit(MUTATIONS.ERROR, message);
                }
            );
        },
        [ACTIONS.GET_BODY]: (context, callback) => {
            Api.getBodyList({
                make: context.state.FILTER_MANUFACTURER
                },
                (response) => {
                    if(response.meta.items > 0) {
                        context.commit(MUTATIONS.FILTER_DATA_BODY, response.data);
                        callback();
                    }
                },
                (message) => {
                    context.commit(MUTATIONS.ERROR, message);
                }
            );
        },
        [ACTIONS.GET_MANUFACTURERS]: (context, bodyList) => {
            Api.getMakes(bodyList, context.state.FILTER_TYPE,
                (response) => {
                    if(response.meta.items > 0) {
                        context.commit(MUTATIONS.FILTER_DATA_MANUFACTURER, response.data);
                        context.commit(MUTATIONS.MANUFACTURER_LIST, response.data);
                        if (response.meta.items === 1) {
                            context.commit(MUTATIONS.FILTER_MANUFACTURER, response.data[0].id);
                        }
                    }
                },
                (message) => {
                    context.commit(MUTATIONS.ERROR, message);
                }
            );
        },
        [ACTIONS.GET_FUEL_TYPES]: (context) => {
            Api.getFuelTypes(
                context.state.FILTER_TYPE,
                (response) => {
                    if(response.meta.items > 0) {
                        context.commit(MUTATIONS.FILTER_DATA_FUEL_TYPES, response.data);
                    }
                },
                (message) => {
                    context.commit(MUTATIONS.ERROR, message);
                }
            );
        },
        [ACTIONS.GET_RANGES]: (context) => {
            const criteria = {
                bodyStyles: context.state.FILTER_BODY,
                make: context.state.FILTER_MANUFACTURER,
                type: context.state.FILTER_TYPE
            };
            Api.getRanges(criteria,
                (response) => {
                    if(response.meta.items > 0) {
                        context.commit(MUTATIONS.FILTER_DATA_MODEL, response.data);
                        context.commit(MUTATIONS.FILTER_MODEL, [])
                    }
                },
                (message) => {
                    context.commit(MUTATIONS.ERROR, message);
                }
            );
        },
        [ACTIONS.EXECUTE_FILTER]: (context, callback) =>{
            context.commit(MUTATIONS.SEARCH_BUSY, true);
            Api.filterFinance(Api.prepareFilterQuery(context.state),
                (response) => {
                    context.commit(MUTATIONS.SEARCH_RESULTS, response.data);
                    context.commit(MUTATIONS.SEARCH_RESULTS_COUNT, response.meta.itemsTotal);
                    context.commit(MUTATIONS.SEARCH_BUSY, false);
                    callback();
                },
                (message) => {
                    context.commit(MUTATIONS.ERROR, message);
                });

        }
    }
})
